import React, { useState, useEffect } from 'react';
import { auth } from '../api';

function Profile() {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    loadCompany();
  }, []);

  const loadCompany = async () => {
    try {
      setLoading(true);
      setLoadError(false);
      const response = await auth.getMe();
      setCompany(response.data);
      setNewName(response.data.name);
    } catch (err) {
      console.error('Failed to load company data:', err);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setNewName(company?.name || '');
    setError(null);
    setSuccess(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setNewName(company?.name || '');
    setError(null);
    setSuccess(false);
  };

  const handleSave = async () => {
    if (!newName || !newName.trim()) {
      setError('Название компании не может быть пустым');
      return;
    }

    if (newName.trim() === company?.name) {
      setIsEditing(false);
      return;
    }

    setSaving(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await auth.updateMe({ name: newName.trim() });
      setCompany(response.data);
      setIsEditing(false);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error('Failed to update company name:', err);
      setError(err.response?.data?.detail || 'Ошибка при сохранении названия компании');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <>
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
            <p className="text-gray-600">Загрузка...</p>
          </div>
        </div>
      </>
    );
  }

  if (loadError) {
    return (
      <div className="max-w-4xl mx-auto">
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-4 flex items-center justify-between gap-4">
          <span>Не удалось загрузить данные</span>
          <button onClick={loadCompany} className="px-3 py-1.5 rounded-lg text-sm font-semibold bg-red-600 text-white hover:bg-red-700 flex-shrink-0">Повторить</button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Личный кабинет</h1>
          
          {success && (
            <div className="mb-6 bg-green-50 border-2 border-green-500 p-4 rounded-lg">
              <p className="text-green-700 font-semibold">Название компании успешно обновлено</p>
            </div>
          )}

          {error && (
            <div className="mb-6 bg-red-50 border-2 border-red-500 p-4 rounded-lg">
              <p className="text-red-700 font-semibold">{error}</p>
            </div>
          )}

          <div className="space-y-6">
            <div className="border-b border-gray-200 pb-6">
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-gray-700">
                  Название компании
                </label>
                {!isEditing && (
                  <button
                    onClick={handleEdit}
                    className="text-blue-600 hover:text-blue-800 font-medium text-sm"
                  >
                    Редактировать
                  </button>
                )}
              </div>
              <div className="mt-1">
                {isEditing ? (
                  <div className="space-y-3">
                    <input
                      type="text"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg"
                      placeholder="Введите новое название компании"
                      disabled={saving}
                      autoFocus
                    />
                    <div className="flex gap-3">
                      <button
                        onClick={handleSave}
                        disabled={saving || !newName.trim() || newName.trim() === company?.name}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {saving ? 'Сохранение...' : 'Сохранить'}
                      </button>
                      <button
                        onClick={handleCancel}
                        disabled={saving}
                        className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Отмена
                      </button>
                    </div>
                  </div>
                ) : (
                  <p className="text-lg text-gray-900 font-semibold">
                    {company?.name || 'Не указано'}
                  </p>
                )}
              </div>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <div className="mt-1">
                <p className="text-lg text-gray-900">
                  {company?.email || 'Не указано'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;

